import React, { useMemo } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

function HighchartsMeasurementGraph({ measurements, measurementType, language = 'en', startDate }) {
  // Hooks en premier pour respecter les règles
  const options = useMemo(() => ({
    chart: {
      type: 'line',
      height: 270,
      backgroundColor: 'transparent',
      style: {
        fontFamily: 'Arial, sans-serif'
      }
    },
    title: {
      text: null
    },
    legend: {
      enabled: true,
      align: 'center',
      verticalAlign: 'bottom',
      layout: 'horizontal',
      itemStyle: {
        fontSize: '10px'
      },
      itemHoverStyle: {
        color: '#666'
      }
    },
    credits: {
      enabled: false
    },
    xAxis: {
      type: 'linear',
      title: {
        text: null
      },
      labels: {
        style: {
          fontSize: '10px'
        }
      },
      tickInterval: 1,
      gridLineWidth: 0,
      lineWidth: 0,
      tickWidth: 0,
      plotLines: [{
        value: 0,
        color: '#999',
        width: 2,
        dashStyle: 'dash',
        label: {
          text: language === 'de' ? 'Operation' : (language === 'fr' ? 'Opération' : 'Operation'),
          style: {
            color: '#666',
            fontSize: '10px'
          },
          rotation: 0,
          y: 10
        }
      }]
    },
    yAxis: {
      title: {
        text: null
      },
      labels: {
        style: {
          fontSize: '10px'
        }
      }
    },

    tooltip: {
      formatter: function() {
        const unit = measurementType === 'weight' ? 'kg' : 
                     measurementType === 'waist' ? 'cm' : 
                     measurementType === 'ketones' ? 'mg/dL' : 
                     measurementType === 'sbp' || measurementType === 'dbp' ? 'mmHg' : 
                     measurementType === 'pulse' ? '/min' : '';
        const dayLabel = language === 'de' ? 'Tag' : language === 'fr' ? 'Jour' : 'Day';
        return `${dayLabel} ${this.x}<br/><strong>${this.y} ${unit}</strong>`;
      }
    },
    plotOptions: {
      line: {
        marker: {
          enabled: true,
          radius: 4,
          symbol: 'circle'
        },
        dashStyle: 'Dash',
        lineWidth: 1
      }
    },
    series: [
      {
        name: language === 'de' ? 'Messungen' : (language === 'fr' ? 'Mesures' : 'Measurements'),
        data: measurements.map(m => { const H1=[-20,-19,-18,-17,-16,-10,-9,-8,-7,-6]; const H2=[-15,-14,-13,-12,-11,-5,-4,-3,-2,-1]; if (H1.includes(m.dayNumber)) { return { x: m.dayNumber, y: m.value, color: '#00B2E6', marker: { fillColor: '#00B2E6', lineColor: '#00B2E6' } }; } if (H2.includes(m.dayNumber)) { return { x: m.dayNumber, y: m.value, color: '#3B82F6', marker: { fillColor: '#3B82F6', lineColor: '#3B82F6' } }; } if (m.dayNumber > 0) { return { x: m.dayNumber, y: m.value, color: '#303030', marker: { fillColor: '#303030', lineColor: '#303030' } }; } return { x: m.dayNumber, y: m.value }; }),
        color: '#9ca3af',
        marker: {
          fillColor: '#9ca3af',
          lineColor: '#9ca3af'
        },
        showInLegend: false
      },
      {
        name: 'Fasten',
        type: 'scatter',
        data: [],
        color: '#00B2E6',
        marker: {
          enabled: true,
          radius: 4,
          symbol: 'circle',
          fillColor: '#00B2E6',
          lineColor: '#00B2E6'
        },
        showInLegend: true,
        enableMouseTracking: false
      },
      {
        name: 'Intervallfasten',
        type: 'scatter',
        data: [],
        color: '#3B82F6',
        marker: {
          enabled: true,
          radius: 4,
          symbol: 'circle',
          fillColor: '#3B82F6',
          lineColor: '#3B82F6'
        },
        showInLegend: true,
        enableMouseTracking: false
      }
    ]
  }), [measurements, measurementType, language, startDate]);

  // Returns conditionnels après les hooks
  if (!measurements || measurements.length === 0) {
    const noData = language === 'de' ? 'Keine Messung' : language === 'fr' ? 'Aucune mesure' : 'No measurement';
    return <div style={{textAlign: 'center'}}>{noData}</div>;
  }

  // Toujours afficher le graphique, même pour une seule mesure

  return (
    <div style={{width: '100%', maxWidth: 500, height: 270, margin: '15px auto 0 auto', display: 'block', background: 'transparent'}}>
      <HighchartsReact
        highcharts={Highcharts}
        options={options}
      />
    </div>
  );
}

export default React.memo(HighchartsMeasurementGraph); 